import { animate, state, style, transition, trigger } from '@angular/animations'
import { Component, HostListener } from '@angular/core'
import { LanguageService } from '../../services/language.service'
import { getRGPDLink, languages } from '../../utils/languages.utils'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('enterTransition', [
      state(
        'void',
        style({
          opacity: 0
        })
      ),
      transition('void <=> *', animate('500ms ease-in'))
    ]),
    trigger('boxTransitionOne', [
      transition(':enter', [
        style({ transform: 'scale(0.9)', opacity: 0 }),
        animate('0.5s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.3s ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ])
    ]),
    trigger('boxTransitionTwo', [
      transition(':enter', [
        style({ transform: 'scale(0.9)', opacity: 0 }),
        animate('0.8s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.3s ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ])
    ]),
    trigger('boxTransitionThree', [
      transition(':enter', [
        style({ transform: 'scale(0.9)', opacity: 0 }),
        animate('1.1s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.3s ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ])
    ])
  ]
})
export class HomeComponent {
  public languages = languages
  public defaultLanguage: any = null
  public studentModalOpened = false
  public trainerModalOpened = false
  public windowWidth = 900
  public getIdsModalOpened = false
  public smallScreen = true

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.smallScreen = window.innerWidth < 1000
  }

  constructor(private languageService: LanguageService) {
    this.windowWidth = window.innerWidth
    this.smallScreen = this.windowWidth < 1000
    this.getLanguages()
  }

  private async getLanguages(): Promise<void> {
    await this.languageService.setDefaultLanguage()
    const storedLanguage = this.languageService.getLanguage()
    this.defaultLanguage = this.languages.find(
      lang => lang.id === storedLanguage
    )
  }

  public selectLanguage(language: any) {
    this.languageService.setLanguage(language.id)
  }

  public goWebsite() {
    window.open(
      `https://sowesign.com/${
        this.languageService.getLanguage() === 'en' ? 'en' : ''
      }`,
      '_blank'
    )
  }

  public goManager() {
    window.open('https://app.sowesign.com/login', '_blank')
  }

  public goIosStudent() {
    window.open(
      'https://apps.apple.com/fr/app/sws-student/id1526138680',
      '_blank'
    )
  }

  public goAndroidStudent() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.sws.student',
      '_blank'
    )
  }

  public goIosTrainer() {
    window.open(
      'https://apps.apple.com/fr/app/sws-trainer/id1562965239',
      '_blank'
    )
  }

  public goAndroidTrainer() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.sws.trainer',
      '_blank'
    )
  }

  public openStudentModal() {
    this.studentModalOpened = true
  }

  public closeStudentModal() {
    this.studentModalOpened = false
  }

  public openTrainerModal() {
    this.trainerModalOpened = true
  }

  public closeTrainerModal() {
    this.trainerModalOpened = false
  }

  public openGetIdsModal() {
    this.getIdsModalOpened = true
  }

  public closeGetIdsModal() {
    this.getIdsModalOpened = false
  }

  public goRGPDLink(linkType: string) {
    window.open(
      getRGPDLink(this.languageService.getLanguage(), linkType),
      '_blank'
    )
  }
}
